import React from 'react';

import AdminCodebookListView from '@src/components/codebook/view/AdminCodebookListView';

const AdminCodebooksPage = () => <AdminCodebookListView />;

export default AdminCodebooksPage;
